import Glide from '@glidejs/glide';
import { debounce } from 'debounce';

var loadingMore = false;

function refreshCartCounter() {
  var cartitems = 0;
  $('#cart-items .qty').each(function() { cartitems += parseInt($(this).val()); });

  var counter = $('header.banner .bag .counter');

  counter.text(cartitems);
  if(cartitems <= 0) {
    counter.hide();
  } else {
    counter.show();
  }
}

function doSearch() {
  if (loadingMore) {
    $('#results').attr('data-page', parseInt($('#results').attr('data-page')) + 1);
    $('#more-products-trigger, main.main').addClass('loading-more')
  } else {
    $('#results').attr('data-page', 1);
  }
  $('main.main').addClass('loading');
  var theCat = $('.shop-cat-select select').val();
  var sortby = $('select.sortby').val();
  var datapage = $('#results').attr('data-page');
  $.ajax({
    type: 'POST',
    url: '/wp/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action: 'custom_filter',
      selected_cat: theCat,
      data_page: datapage,
      sort_by: sortby,
    },
    success: function(response) {
      if (loadingMore) {
        $(response.products).appendTo('#results');
        window.yotpo.initWidgets();
      } else {
        $('#results').html(response.products);
        $('#more-products-trigger').attr('data-total', response.pages);
        history.pushState({}, response.pagetitle, response.url);
        window.yotpo.initWidgets();
        $('html, body').animate({
          scrollTop: $('#results').offset().top - 260,
        }, 750, 'swing');
      }
      loadingMore = false;
      executeOnScroll();
      $('main.main, #more-products-trigger').removeClass('loading loading-more');
    },
    error: function() {
      loadingMore = false;
      $('main.main, #more-products-trigger').removeClass('loading loading-more');
    },
  });
  return false;
}

updateCartSelf();

updatePage();

function updatePage() {
  $.ajax({
    type: 'POST',
    url: '/wp/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action: 'update_page',
    },
    success: function(response) {
      if (response.login === 'true') {
        $('.user__not-logged').hide();
        $('.user__is-logged').show();
      } else {
        $('.user__not-logged').show();
        $('.user__is-logged').hide();
      }
    },
  });
}

function updateCartSelf() {
  const is_checkout = $('.woocommerce-checkout').length ? true : false;
  $('#cart-items').addClass('loading');
  $.ajax({
    type: 'POST',
    url: '/wp/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action: 'cart_items',
      is_checkout: is_checkout,
    },
    success: function(response) {
      $('#cart-items').html(response.cartitems).removeClass('loading');
      $('#cart-count').html(response.cartcount);
      $('.single_add_to_cart_button').removeClass('loading');
      refreshCartCounter();
      $('.global-cart-inner .cart-discount').remove();
      $('.global-cart-inner .cart-header').after(response.couponshtml);
      var wrapper = $('.remaining-to-free-shipping');
      var bar = $('.global-cart .progress-bar');
      var barInner = $('.global-cart .progress-bar-inner');
      var msg = $('.global-cart .remaining-to-free-shipping p');

      if(response.cartcount === 'Cart') {
        wrapper.hide();
      } else {
        wrapper.show();
        barInner.css('width', response.fsPercent + '%');
        $('.global-cart .progress-bar-inner span').text(response.fsPercent + '%');
        if(response.fsCoupon) {
          barInner.addClass('full');
          bar.hide();
          wrapper.css('padding-bottom', '2rem');
        } else if(response.fsPercent < 100) {
          barInner.removeClass('full');
          bar.show();
          wrapper.css('padding-bottom', '4.5rem');
        } else {
          barInner.addClass('full');
          bar.show();
          wrapper.css('padding-bottom', '4.5rem');
        }
        msg.html(response.fsMessage);
        if(response.fsCoupon) {
          msg.css('margin-bottom', '0');
        } else {
          msg.css('margin-bottom', '1.5rem');
        }
      }
      isApplePay();
      $('body').trigger('updated_cart_totals');
    },
    error: function() {
      $('#cart-items').removeClass('loading');
      $('.single_add_to_cart_button').removeClass('loading');
    },
  });
}

function updateCart() {
  const is_checkout = $('.woocommerce-checkout').length ? true : false;
  $('#cart-items').addClass('loading');
  $.ajax({
    type: 'POST',
    url: '/wp/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action: 'cart_items',
      is_checkout: is_checkout,
    },
    success: function(response) {
      $('#cart-items').html(response.cartitems).removeClass('loading');
      $('#cart-count').html(response.cartcount);
      if (!is_checkout) {
        $('.global-cart').addClass('open');
        $('body').addClass('noscroll');
      }
      $('.single_add_to_cart_button').removeClass('loading');
      refreshCartCounter();
      $('.global-cart-inner .cart-discount').remove();
      $('.global-cart-inner .cart-header').after(response.couponshtml);
      var wrapper = $('.remaining-to-free-shipping');
      var bar = $('.global-cart .progress-bar');
      var barInner = $('.global-cart .progress-bar-inner');
      var msg = $('.global-cart .remaining-to-free-shipping p');

      if(response.cartcount === 'Cart') {
        wrapper.hide();
      } else {
        wrapper.show();
        barInner.css('width', response.fsPercent + '%');
        $('.global-cart .progress-bar-inner span').text(response.fsPercent + '%');
        if(response.fsCoupon) {
          barInner.addClass('full');
          bar.hide();
          wrapper.css('padding-bottom', '2rem');
        } else if(response.fsPercent < 100) {
          barInner.removeClass('full');
          bar.show();
          wrapper.css('padding-bottom', '4.5rem');
        } else {
          barInner.addClass('full');
          bar.show();
          wrapper.css('padding-bottom', '4.5rem');
        }
        msg.html(response.fsMessage);
        if(response.fsCoupon) {
          msg.css('margin-bottom', '0');
        } else {
          msg.css('margin-bottom', '1.5rem');
        }
      }

      isApplePay();
      $('body').trigger('updated_cart_totals');
    },
    error: function() {
      $('#cart-items').removeClass('loading');
      $('.single_add_to_cart_button').removeClass('loading');
      alert('An unexpected error occurred! Please try again.');
    },
  });
  return false;
}


function updateCartQuantity(qty) {
  $('#cart-items').addClass('loading');

  $.ajax({
    type: 'POST',
    url: '/wp/wp-admin/admin-ajax.php',
    dataType: 'json',
    data: {
      action: 'change_cart_item_quantity',
      cart_item_key: String(qty.parents('.item-info').children('.remove').data('cart-item-key')),
      quantity: qty.val(),
    },
    success: function() {
      updateCart();
    },
    error: function() {
      $('#cart-items').removeClass('loading');
      $('.single_add_to_cart_button').removeClass('loading');
      alert('An unexpected error occurred! Please try again.');
    },
  });
}

const lazyCartQuantityUpdate = debounce(updateCartQuantity, 600);

function isApplePay() {
  if (window.ApplePaySession) {
    $('#wc-stripe-payment-request-wrapper').addClass('apple-pay-button');
  } else {
    $('#wc-stripe-payment-request-wrapper').addClass('google-pay-button');
  }
}

isApplePay();

// Checks if elements are visible, for lazy loading and such
function isOnScreen(x) {
  if(x.length) {
    var top_of_element = x.offset().top;
    var bottom_of_screen = $(window).scrollTop() + window.innerHeight;
    if (bottom_of_screen > top_of_element) {
      return true;
    } else {
      return false;
    }
  }
}

var position = $(window).scrollTop();
var scrolled = $(window).scrollTop();
var headerHeight = $('header.banner').height();
$(window).load(function() {
  headerHeight = $('header.banner').height();
});

function executeOnScroll() {
  // Adding class if elements with these classes have scrolled into view
  $('.fadein').each(function() {
    if (isOnScreen($(this))) {
      $(this).addClass('onscreen');
      setTimeout(function() {
        $(this).addClass('finished');
      }, 700);
    } else {
      $(this).removeClass('onscreen finished');
    }
  });

  $('img[custom-lazy]:not([lazy-loaded])').each(function() {
    if (isOnScreen($(this))) {
      $(this).attr('src', $(this).attr('custom-lazy'));
      $(this).attr('lazy-loaded', '');
    }
  });

  if ($(window).scrollTop() > 10) {
    $('header.banner').addClass('shadow');
  } else {
    $('header.banner').removeClass('shadow');
  }

  if ($('body').hasClass('archive') && !$('main.main').hasClass('loading')) {
    if (isOnScreen($('#more-products-trigger')) && loadingMore === false) {
      if (parseInt($('#results').attr('data-page')) < $('#more-products-trigger').attr('data-total')) {
        loadingMore = true;
        doSearch();
      }
    }
  }

  if ($(window).width() < 769 && !$('body').hasClass('checkout')) {
    scrolled = $(window).scrollTop();
    if (scrolled <= position && scrolled > headerHeight) {
      $('header.banner').addClass('stick');
    } else if (scrolled <= headerHeight) {
      $('header.banner').addClass('top');
    } else {
      $('header.banner').removeClass('stick top');
    }
    position = scrolled;
  }
}

var userScrolled = false;
var refreshspeed = 1000 / 10;
$(window).on('scroll', function() {
  userScrolled = true;
}).scroll();

function checkIfScrolled() {
  if (userScrolled) {
    window.requestAnimationFrame(executeOnScroll);
    userScrolled = false;
  }
}

setInterval(checkIfScrolled, refreshspeed);

// function repositionMenu() {
//   var menuleft = $('.nav-primary').offset().left;
//   $('.nav-primary-inner > .sub-menu').css('left', -menuleft);
// }

export default {
  init() {
    // Fix megamenu positioning on window resize
    $(window).on('resize', function() {
      if($(window).width() >= 1150) {
        $('header.banner .burger').removeClass('menu-open');
        $('header.banner .nav-primary').removeAttr('style');
      }
    });

    $(document).ready(function() {
      // Functions to check for and for closing sale banner
      if (!window.localStorage.getItem('closedSaleBanner') || window.localStorage.getItem('timeSaleBannerClosed') <= (Date.now() - (24*60*60*1000))) {
        window.localStorage.setItem('closedSaleBanner', false);
        $('.header-sale-banner').slideDown(200);
      }

      // $(document.body).trigger('updated_cart_totals');

      $('.header-sale-banner .x').click(function() {
        window.localStorage.setItem('closedSaleBanner', true);
        window.localStorage.setItem('timeSaleBannerClosed', Date.now());
        $('.header-sale-banner').addClass('closed');
        $('.header-sale-banner').slideUp(300);
      });

    });

  },
  finalize() {

    $(document).on('cart_update', function() {
      updateCart();
    });

    $(window).load(function() {
      // $('.load-overlay').addClass('loaded');
      $(document).on('click', '.global-cart .woocommerce-form-coupon button[name="apply_coupon"]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const coupon = $('#coupon_code').val();
        const successHtml = '<div class="cart-discount code-applied"><p>Coupon code <strong>' + coupon + '</strong> successfully applied!</p></div>';
        const wrongHtml = 'Coupon code <strong>' + coupon + '</strong> is Invalid!';

        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'bbe_add_coupon_action',
            couponcode: coupon,
          },
          success: function(response) {
            if (response.message === 'valid') {
              if (response.refresh_cart === 1) {
                updateCart();
              }

              var rew_amt = response.reward_amt ? parseInt(response.reward_amt) : '';
              if(rew_amt) {
                $('#coupon_code').val('');
                $('.bucks-message').prepend('Redeemed <span class="used-points">' + rew_amt + '</span> points for a <span class="discount-amt">$' + rew_amt.toFixed(2) + '</span> discount on this order!');
                $('.bucks-message').show();
              } else {
              $('.cart-discount, .woocommerce-form-coupon').html(successHtml);
              $('.cart-discount').append('<span class="cart-discount__remove cart-discount__remove--visible"></span>');
              }
            } else {
              if(response.custom_message) {
                $('.cart-discount p, .woocommerce-form-coupon p').html(response.custom_message);
              } else {
                $('.cart-discount p, .woocommerce-form-coupon p').html(wrongHtml);
              }
            }
            if(response.rewards_coupon_applied) {
              $('.choose-bucks').hide();
            }
          },
          error: function(response) {
            if (response.message === 'valid') {
              if (response.refresh_cart === 1) {
                updateCart();
              }

              var rew_amt = response.reward_amt ? parseInt(response.reward_amt) : '';
              if(rew_amt) {
                $('#coupon_code').val('');
                $('.bucks-message').prepend('Redeemed <span class="used-points">' + rew_amt + '</span> points for a <span class="discount-amt">$' + rew_amt.toFixed(2) + '</span> discount on this order!');
                $('.bucks-message').show();
              } else {
              $('.cart-discount, .woocommerce-form-coupon').html(successHtml);
              $('.cart-discount').append('<span class="cart-discount__remove cart-discount__remove--visible"></span>');
              }
            } else {
              if(response.custom_message) {
                $('.cart-discount p, .woocommerce-form-coupon p').html(response.custom_message);
              } else {
                $('.cart-discount p, .woocommerce-form-coupon p').html(wrongHtml);
              }
            }
          },
        });
      });

      $(document).on('click', '.cart-discount__remove', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var reward = false;
        if($(this).hasClass('remove-reward')) {
          reward = true;
        }

        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'bbe_remove_coupon_action',
            removeReward: reward,
          },
          success: function(response) {
            updateCart();
            if(!$('body').hasClass('checkout')) {
              if(reward) {
                $('.bucks-message').hide().html('<span class="cart-discount__remove remove-reward"></span>');
              } else if(response.content) {
                $('.global-cart-inner .cart-discount').remove();
                $('.global-cart-inner .cart-header').after(response.content);
              }
            } else {
              $('body').trigger('update_checkout');
              $('.before-customer-details').empty();
              if(response.content) {
                $('.checkout-title .checkout_coupon').remove();
                $('.checkout-title .checkout-header-options__coupon-col').html(response.content);
                $('.checkout-checkbox').show();
              }
            }
            if(!response.rewards_coupon_applied) {
              $('.choose-bucks').show();
            }
          },
          error: function(response) {
            updateCart();
            if(!$('body').hasClass('checkout')) {
              if(response.content) {
                $('.global-cart-inner .cart-discount').remove();
                $('.global-cart-inner .cart-header').after(response.content);
                $('.checkout-checkbox').show();
              }
            } else {
              $('body').trigger('update_checkout');
              if(response.content) {
                $('.checkout-title .checkout_coupon').remove();
                $('.checkout-title .checkout-header-options__coupon-col').html(response.content);
              }
            }
          },
        });
      });

      executeOnScroll();

      // live chat open on menu button click
      if ($('#help-live').length) {
        $('#help-live, .help-live').on('click', function() {
          window.LC_API.open_chat_window();
        });
      }

      if ($('.featured-posts__slider').length) {
        new Glide('.featured-posts__slider', {
          type: 'carousel',
          perView: 3,
          gap: 10,
          breakpoints: {
            1023: {
              perView: 2,
            },
            767: {
              perView: 1,
            },
          },
        }).mount();
      }

      if ($('.seen-in-carousel').length) {
        const seenIn = new Glide('.seen-in-carousel', {
          type: 'carousel',
          startAt: 0,
          perView: 3,
          animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
          gap: 80,
          breakpoints: {
            1023: {
              perView: 2,
            },
            767: {
              perView: 1,
            },
          },
        });

        seenIn.mount();
      }

      new Glide('.header-notifs', {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        autoplay: 7000,
        hoverpause: true,
        animationDuration: 1500,
        animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
      }).mount();
    });

    // Adding account to mobile menu
    if ($(window).width() <= 1024) {
      $('.nav-primary-inner').append('<span><a href="' + $('.nav-secondary li.account > a').attr('href') + '">Account</a></span>');
      $('.nav-primary-inner').append($('.nav-secondary li.account .sub-menu').addClass('account').wrap('<span/>').parent().html());
    }

    // Toggling primary menu
      $(document).on('click', 'header.banner .burger', function () {
          $('.nav-primary-inner .sub-menu').removeAttr('style');
          $(this).toggleClass('menu-open');

          $(this).next('.nav-primary').slideToggle(200);
          $('.nav-primary-inner > span').removeClass('sub-open');
          $('.nav-primary-inner .sub-menu').slideUp(200);
      });

    $('.nav-secondary li.search a').click(function(e) {
      e.preventDefault();
      $(this).siblings('.search-field').toggleClass('open');
      if($(this).siblings('.search-field').hasClass('open')) {
        $(this).next().find('input[type="search"]').focus();
      }
      if ($(window).width() <= 1024) {
        $('.nav-primary-inner > span').removeClass('sub-open');
        $('.nav-primary-inner .sub-menu').slideUp(200);
        $('.nav-primary').slideUp(200);
      }
    });
    $(document).mouseup(function(e) {
      var container = $('.nav-secondary li.search');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('header.banner .search-field').removeClass('open');
      }
    });

    // Toggling Affiliate menu
    $(document).on('click', '.affiliate-mobile-nav .affiliate-mobile-nav-icon', function() {
      $(this).toggleClass('menu-open');
      if ($('#menu-affiliate-dashboard-navigation').css('display') == 'none') {
        $('#menu-affiliate-dashboard-navigation').slideDown(200);
      } else {
        $('#menu-affiliate-dashboard-navigation').slideUp(200);
      }
    });

    // Smooth scroll to anchor tag
    $(document).on('click', 'a[href^="#"]:not(a[href="#"]):not([href="#jointhemovement"]):not([href^="#tab"]):not([href*="#dirtydozen"])', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top - $('header.banner').height() - $('section.about-nav').height() - 20,
      }, 750, 'swing');
    })

    $('.nav-primary-inner > span').click(function() {
      $(this).toggleClass('sub-open');
      $(this).next('.sub-menu').slideToggle(200);
    });

    $('.nav-primary-inner > span > a').click(function(e) {
      e.stopPropagation();
    });

    $('.nav-secondary .bag').click(function(e) {
      e.preventDefault();
      $('.global-cart').addClass('open');
      $('body').addClass('noscroll');
    });

    $('.global-cart .close, .global-cart .x, .global-cart').click(function(e) {
      if (e.target !== this) return;
      $('.global-cart').removeClass('open');
      $('body').removeClass('noscroll');
    });

    $(document).on('click', '.quantity .increase', function() {
      $(this).prev('input').val(parseInt($(this).prev('input').val()) + 1);
    });

    $(document).on('click', '.quantity .decrease', function() {
      if ($(this).next('input').val() > 1) {
        $(this).next('input').val(parseInt($(this).next('input').val()) - 1);
      }
    });

    $(document).on('change', '.shop-cat-select select', function() {
      $('.sidebar .refine-by input[name="cat"][value="' + $(this).val() + '"]').prop('checked', true);
      doSearch();
    });

    $(document).on('change', '.sidebar .refine-by input[name="cat"]', function() {
      $('.shop-cat-select select').val($('.refine-by input[name="cat"]:checked').val());
      doSearch();
    });

    $(document).on('change', '.sidebar select.sortby', function() {
      doSearch();
    });

    $(document).on('click', '.sidebar .refine-by > ul > li', function() {
      $(this).children('.filter-sub').slideToggle(200);
    });

    $(document).on('click', '.sidebar .refine-by > ul > li .filter-sub', function(e) {
      e.stopPropagation();
    });

    $(document).on('click', '.cart-item .remove', function(e) {
      e.preventDefault();
      $('#cart-items, .checkout-cart').addClass('loading');
      $.ajax({
        type: 'POST',
        url: '/wp/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
          action: 'remove_item_from_cart',
          cart_item_key: String($(this).data('cart-item-key')),
        },
        success: function() {
          updateCart();
        },
        error: function() {
          $('#cart-items, .checkout-cart').removeClass('loading');
        },
      });
    });

    $(document).on('change', '.global-cart .quantity .qty', function() {
      lazyCartQuantityUpdate($(this));
    });
    $(document).on('click', '.global-cart .quantity .increase, .global-cart .quantity .decrease', function() {
      lazyCartQuantityUpdate($(this).siblings('.qty'));
    });

    $(document).on('click', '.checkout-options .continue', function(e) {
      e.preventDefault();
      $('.global-cart').removeClass('open');
      $('body').removeClass('noscroll');
    });

    $('.show-register').on('click', function(e) {
      e.preventDefault();
      $('.login-wrap').toggleClass('register');
    });

    $('.toggle-cats').click(function() {
      $(this).toggleClass('open');
      $('.categories-list').toggleClass('open').slideToggle(200);
    });

    // Making custom gutenburg accordions work
    $('.wp-block-columns.has-2-columns.accordion > .wp-block-column:first-child').click(function() {
      $(this).toggleClass('open');
      $(this).next('.wp-block-column:last-child').slideToggle(200);
    })

    $('.common-wrap .not-sidebar [id], .template-faq .not-sidebar [id]').each(function() {
      $('ul.table-of-contents').append('<li><a href="#' + $(this).attr('id') + '">' + $(this).text() + '</a></li>');
    });

    $(window).on('load', function() {
      if ($(window).width() < 769 && $('.sidebar .sidebar-message').length) {
        $('.products li:eq(3)').after('<li class="sidebar-message sidebar-message--in-loop">' + $('.sidebar .sidebar-message').html() + '</li>').after('<li style="display: none;">used to fix css nth-child styling</li>');
      } else {
        $('.products .sidebar-message').remove();
      }
    });

    $(document).on('click', '.sub-menu a[href^="#"]', function() {
      if($(window).width() > 768) {
        $('.sub-menu').css('pointer-events', 'none');
        setTimeout(function() {
          $('.sub-menu').css('pointer-events', 'initial');
        }, 1000);
      } else {
        $('.nav-primary').slideUp(200);
      }
    });

    $(document).on('click', 'a', function(e) {
      if ($(this).attr('href').indexOf('/cart') >= 0) {
        e.preventDefault();
        $('.global-cart').addClass('open');
        $('body').addClass('noscroll');
      }
    });

    $(document).on('click', '.table-of-contents-wrap h4', function() {
      $(this).toggleClass('open').next('ul').slideToggle(200);
    });

    $(document).on('click', '.view_cart', function(e) {
      e.preventDefault();
      $('.global-cart').addClass('open');
      $('body').addClass('noscroll');
    });

    $('body').on('added_to_cart', function() {
      updateCart();
    });

    if (location.hash) {
      setTimeout(function() {
        window.scrollTo(0, 0);
      }, 1);
      $('html, body').animate({
        scrollTop: $(location.hash).offset().top - $('header.banner').height() - $('section.about-nav').height() - 20,
      }, 750, 'swing');
    }

    $(document).on('change', '.global-cart .wjecf-select-free-products input[type=radio]', () => {
      const is_checkout = $('.woocommerce-checkout').length ? true : false;
      let product_id = $('.wjecf-select-free-products input[type=radio]:checked').val();
      if (is_checkout) {
        $('.checkout .wjecf-select-free-products input[value='+product_id+']').trigger('click');
      } else {
        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'update_freegift',
            item: product_id,
            form: $('.woocommerce-cart-form').serialize(),
          },
          success: function() {
            updateCart();
          },
        });
      }
    });
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js